import ManifestoVideo from "./ManifestoVideo";
import { LogoStrip } from "./LogoStrip";

// Client, 2026-10-08: the two stat cards ("4 Disciplines" / "1 Insanely Driven
// Team") are gone from this band. The section is the headline + film, then the
// full-bleed "Brands we've worked with" rail.
export default function Manifesto() {
  return (
    <section className="gm-manifesto theme-yellow" id="about" data-testid="manifesto-section">
      <div className="container-gm">
        <div className="gm-manifesto__grid">
          <div className="gm-manifesto__intro">
            <h2 className="display-md" data-reveal="mask">
              Great venues deserve great events. We build them
            </h2>
          </div>
          <div className="gm-manifesto__media" data-reveal="fade">
            {/* Client, 2026-09-18: video in the same card box; the filmstrip is gone. */}
            <ManifestoVideo />
          </div>
        </div>
      </div>

      {/* Client, 2026-10-07: the partner logos leave the landing footer and run
          here as "Brands we've worked with". 2026-10-08: heading at full section
          size, centred; logos on a full-width rotating rail - so the strip sits
          OUTSIDE the container and manages its own width. */}
      <LogoStrip />
    </section>
  );
}
